export const deleteKey = "delete";
export const deleteProcessKey = "deleteProcess";
export const restoreKey = "undelete";
export const restoreProcessKey = "restoreProcess";
